import { api } from "boot/axios";

export default () => {
  //Register FCM
  const registerFCM = async (registrationId) => {
    try {
      const data = await api.post("/notification/v2/register-notif-token/", {
        registration_id: registrationId,
        type: process.env.IS_CAPACITOR ? "android" : "web",
      });
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //get Notifications

  const getNotifications = async () => {
    try {
      const data = await api.get("/notification/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //mark Notifications as viewed
  const updateNotificationState = async (id, viewed) => {
    try {
      const data = await api.put("/notification/" + id, viewed);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //get general Notifications

  const getGeneralNotifications = async () => {
    try {
      const data = await api.get("/notification/general/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  return {
    registerFCM,
    getNotifications,
    updateNotificationState,
    getGeneralNotifications,
  };
};
